import { Link } from "react-router-dom";
import { modules } from "../data/modules";
import { useAuth } from "../contexts/AuthContext";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Capacitor } from "@capacitor/core";

export default function Home() {
    const { user } = useAuth();
    const isNativeApp = Capacitor.isNativePlatform();
    useEffect(() => {

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });


    }, []);


    return (
        <>
            <Helmet>
                <title>
                    Figure It Out | Build Practical Thinking Skills
                </title>

                <meta
                    name="description"
                    content="Build practical thinking skills through 36 interactive activities. Improve focus, organisation, memory, communication, critical thinking and problem-solving."
                />
            </Helmet>

            <div
                style={{
                    maxWidth: "1000px",
                    margin: "0 auto",
                    padding: "2rem"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "12px",
                        marginBottom: "1rem",
                    }}
                >
                    {user ? (
                        <>
                            <Link to="/progress">
                                My Progress
                            </Link>

                            {" | "}

                            <Link to="/journal">
                                Learning Journal
                            </Link>

                            {" | "}

                            <Link to="/account">
                                My Account
                            </Link>
                        </>
                    ) : (
                        <Link to="/login">
                            Save Progress
                        </Link>
                    )}
                </div>
                <header
                    style={{
                        textAlign: "center",
                        marginBottom: "5rem"
                    }}
                >
                    <img
                        src="/logo.png"
                        alt="Figure It Out"
                        style={{
                            width: "240px",
                            maxWidth: "100%",
                            marginBottom: "1rem"
                        }}
                    />
                    {user && (

                        <p>

                            Welcome back
                            {user.displayName
                                ? `, ${user.displayName}`
                                : ""}!

                        </p>

                    )}
                    <p
                        style={{
                            fontSize: "1.2rem",
                            maxWidth: "650px",
                            margin: "0 auto",
                            lineHeight: "1.7"
                        }}
                    >
                        Build practical skills for learning,
                        communication, problem solving and
                        critical thinking through interactive
                        challenges.
                    </p>
                </header>
                <div
                    style={{
                        marginTop: "2rem",
                        textAlign: "center"
                    }}
                >
                    <a
                        href="#categories"
                        style={{
                            display: "inline-block",
                            padding: "0.75rem 1.5rem",
                            border: "1px solid #1d3557",
                            borderRadius: "8px",
                            textDecoration: "none",
                            color: "#1d3557",
                            fontWeight: "600"
                        }}
                    >
                        Explore Activities
                    </a>
                </div>
                <section
                    style={{
                        marginTop: "4rem",
                        marginBottom: "3rem"
                    }}
                >
                    <h2>Why Use Figure It Out?</h2>

                    <p>
                        Most educational websites teach information.
                    </p>

                    <p>
                        Figure It Out helps you develop the skills
                        behind success:
                    </p>

                    <ul
                        style={{
                            listStyle: "none",
                            padding: 0,
                            lineHeight: "2"
                        }}
                    >
                        <li>🔍 Notice More</li>
                        <li>🎯 Focus Better</li>
                        <li>📦 Get Organised</li>
                        <li>🛠️ Solve Problems</li>
                        <li>🧠 Think Clearly</li>
                        <li>💬 Work With People</li>
                    </ul>
                </section>

                <section id="categories">
                    <h2>Explore Categories</h2>

                    {modules.map((module) => (
                        <div
                            key={module.id}
                            style={{
                                border: "1px solid #ddd",
                                borderRadius: "12px",
                                padding: "1.5rem",
                                marginBottom: "1rem",
                                background: "#fff",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                            }}
                        >
                            <h3 style={{ marginTop: 0 }}>
                                {module.title}
                            </h3>

                            <p
                                style={{
                                    marginBottom: "1rem"
                                }}
                            >
                                {module.description}
                            </p>

                            <Link
                                to={`/module/${module.id}`}
                                style={{
                                    fontWeight: "600",
                                    textDecoration: "none"
                                }}
                            >
                                Explore →
                            </Link>
                        </div>
                    ))}
                </section>
                <section
                    style={{
                        textAlign: "center",
                        marginTop: "3rem"
                    }}
                >
                    <h2>Build Practical Thinking Skills</h2>

                    <p>
                        {modules.reduce(
                            (total, module) =>
                                total + module.activities.length,
                            0
                        )} interactive activities across{" "}
                        {modules.length} categories designed
                        to strengthen real-world thinking skills.
                    </p>
                </section>
                <section
                    style={{
                        marginTop: "3rem",
                        paddingTop: "2rem",
                        borderTop: "1px solid #ccc",
                        textAlign: "center"
                    }}
                >
                    <p>
                        {modules.length} categories •{" "}
                        {modules.reduce(
                            (total, module) =>
                                total + module.activities.length,
                            0
                        )} activities
                    </p>

                    <nav
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "1rem",
                            flexWrap: "wrap"
                        }}
                    >
                        <Link to="/about">About</Link>
                        <Link to="/contact">Contact</Link>
                        <Link to="/privacy">Privacy</Link>
                        <Link to="/terms">Terms</Link>
                        <Link to="/credits">Credits</Link>
                    </nav>
                    {!isNativeApp && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                gap: "1rem",
                                flexWrap: "wrap",
                                marginTop: "1.5rem",
                                marginBottom: "1.5rem"
                            }}
                        >
                            <a
                                href="https://play.google.com/store/apps/details?id=now.figureitout.platform"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Get Figure It Out on Google Play"
                            >
                                <img
                                    src="/badges/google-play.png"
                                    alt="Get it on Google Play"
                                    style={{
                                        height: "56px",
                                        width: "auto"
                                    }}
                                />
                            </a>

                            <a
                                href="https://apps.apple.com/us/app/figure-it-out-think-better/id6792431196"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Download Figure It Out on the App Store"
                            >
                                <img
                                    src="/badges/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
                                    alt="Download on the App Store"
                                    style={{
                                        height: "46px",
                                        width: "auto"
                                    }}
                                />
                            </a>
                        </div>
                    )}
                    <a
                        href="https://www.facebook.com/figureitout.au"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow Figure It Out on Facebook"
                        style={{
                            display: "inline-block",
                            marginTop: "1.5rem"
                        }}
                    >
                        <img
                            src="/facebook.png"
                            alt="Facebook"
                            style={{
                                width: "34px",
                                height: "34px",
                                transition: "transform 0.2s"
                            }}
                        />
                    </a>

                    <p
                        style={{
                            marginTop: "1rem",
                            fontSize: "0.85rem",
                            color: "#666"
                        }}
                    >
                        © 2026 Figure It Out
                    </p>
                </section>

            </div>
        </>
    );
}